<div class="empty-state-container">
    <i class="icon" [class]="icon"></i>
    <p>{{ text1 }}</p>
    <p class="small-text">
        @if (text2) {
            <span>{{ text2 }}</span>
        }
        @if (btnText) {
            <a [routerLink]="btnLink" id="empty-state-button" class="p-button-text">
                {{ btnText }}
            </a>
        }
    </p>
</div>
